module.exports = __webpack_public_path__ + "img/03.eeb6f09f.jpg";